import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Divider, Grid, Stack, Text } from "@mantine/core";
import GpaReportHeader from "../common/OpaReportHeader";
import BaselineSection from "./sections/BaselineSection";
import StatisticsLegand from "../../comon/StatisticsLegand";
import NewVfiChart from "../charts/NewVfiChart";

export default function BaselinePage(props) {
  const { t } = useTranslation();
  const [eye, setEye] = useState(null);
  const [type, setType] = useState(null);
  const [name, setName] = useState("");
  const [dob, setDob] = useState("");
  const [patientId, setPatientId] = useState("");
  const [values, setValues] = useState([]);
  const [vfis, setVfis] = useState(0);

  useEffect(() => {
    if (props.calculatedValues) {
      setValues(props.calculatedValues);
    }
    if (props.vfis) {
      setVfis(props.vfis);
    }
    console.log("props", props);
  }, [props]);

  useEffect(() => {
    const val = values[0];
    setEye(val?.eye ?? null);
    setType(val?.testType ?? null);
    setName(val?.patient?.name ?? "");
    setDob(val?.patient?.dob ?? "");
    setPatientId(val?.patient?.uuid ?? "");
  }, [values]);

  const divider = <Divider size={"md"} variant="dashed" color="gray.6" />;
  const headerText = (text) => (
    <Text ta="center" fw={600} size={"lg"} c="dimmed">
      {text}
    </Text>
  );

  return (
    <Stack>
      <Box p={"lg"}>
        <GpaReportHeader
          title={"Baseline"}
          name={name}
          dob={dob}
          type={type}
          uuid={patientId}
          eye={eye}
        />
        <Stack my={"sm"}>
          <Grid>
            <Grid.Col span={3}>{headerText(t("grayTone"))}</Grid.Col>
            <Grid.Col span={3}>{headerText(t("threshold"))}</Grid.Col>
            <Grid.Col span={3}>{headerText(t("totalDeviation"))}</Grid.Col>
            <Grid.Col span={3}>{headerText(t("patternDeviation"))}</Grid.Col>
          </Grid>
          {values.map((val) => (
            <>
              <BaselineSection test={val} halfMaps={false} />
              {divider}
            </>
          ))}
          <NewVfiChart data={vfis} />
          <Divider size={"sm"} color="gray.6" />
          <StatisticsLegand cols={4} />
          <Divider size={"md"} variant="dotted" color="gray.6" my="lg" />
        </Stack>
      </Box>
    </Stack>
  );
}
